(function (Wishlist) {

  // 変数の初期化
  const wishlistButtons = document.querySelectorAll('.wishlist-btn');
  const wishlistItemCount = document.querySelector('.wishlist-item-count');
  let wishlist = localStorage.getItem('user_wishlist') || '[]';

  try {
    wishlist = JSON.parse(wishlist);
  } catch (e) {
    wishlist = [];
  }

  // UIアニメーション関数
  function animateWishlist(button) {
    button.classList.toggle('is-active');
  }

  // ウィッシュリストの追加/削除
  function updateWishlist(button) {
    const productHandle = button.getAttribute('data-product-handle');
    const isRemove = button.classList.contains('is-active');

    if (isRemove) {
      const removeIndex = wishlist.indexOf(productHandle);
      if (removeIndex > -1) {
        wishlist.splice(removeIndex, 1);
      }
    } else {
      wishlist.push(productHandle);
    }

    localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
  }

  // ウィッシュリストボタンの状態を初期化
  function activateItemsInWishlist() {
    wishlistButtons.forEach(function (button) {
      const productHandle = button.getAttribute('data-product-handle');
      if (wishlist.includes(productHandle)) {
        button.classList.add('is-active');
      }
    });
  }

  // ウィッシュリストページの商品をロード
  function loadWishlistPage() {
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      const loader = document.querySelector('.wishlist-loader');
      const wishlistGrid = document.querySelector('.wishlist-grid');
      const emptyList = document.querySelector('.wishlist-grid--empty-list');

      // ローダーを表示
      if (loader) {
        loader.style.display = 'block';
      }

      // ウィッシュリストが空の場合
      if (wishlist.length === 0) {
        if (loader) loader.style.display = 'none';
        if (emptyList) emptyList.classList.add('is_visible');
        return; // 処理を終了
      }

      // Shopify Ajax APIで商品情報を取得
      const productHandles = wishlist.join('+OR+handle:');
      const url = `/search?q=handle:${productHandles}`;

      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text(); // JSONではなく、HTMLとして取得
        })
        .then(html => {
          // HTMLをパースして商品タイルを抽出
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const products = doc.querySelectorAll('.wishlist-tile-container');

          const wishlistContainer = document.querySelector('#wishlist-product-grid');
          if (wishlistContainer) {
            wishlistContainer.innerHTML = ''; // 既存のアイテムをクリア
            if (products.length > 0) {
              products.forEach(tile => {
                wishlistContainer.appendChild(tile);
              });
              if (emptyList) emptyList.style.display = 'none';
            } else {
              if (emptyList) emptyList.classList.add('is_visible');
            }
          }
        })
        .catch(error => {
          console.error('Error fetching wishlist products:', error);
          if (emptyList) emptyList.classList.add('is_visible');
        })
        .finally(() => {
          // 最後にローダーを非表示にする
          if (loader) {
            setTimeout(() => {
              loader.style.display = 'none';
              if (wishlistGrid) wishlistGrid.classList.add('is_visible');
              const wishlistHero = document.querySelector('.wishlist-hero');
              if (wishlistHero) wishlistHero.classList.add('is_visible');
            }, 500); // ローディング完了を少し遅延させて見せる
          }
        });
    }
  }

  // ウィッシュリストアイテム数を更新
  function updateWishlistItemCount() {
    if (wishlistItemCount && wishlist) {
      wishlistItemCount.textContent = wishlist.length;
    }
  }

  // UIアクションのバインド
  function bindUIActions() {
    wishlistButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        updateWishlist(button);
        animateWishlist(button);
        updateWishlistItemCount();
      });
    });
  }

  // ウィッシュリストの初期化
  Wishlist.init = function () {
    bindUIActions();
    activateItemsInWishlist();
    loadWishlistPage();
    updateWishlistItemCount();
  };

})(window.Wishlist = window.Wishlist || {});